// extracted by mini-css-extract-plugin
module.exports = {"announcement":"Announcement_announcement__zQyBw","announcementField":"Announcement_announcementField__1Tx1r"};